import React from 'react' ;
import {Redirect, Route, Switch} from 'react-router-dom';
import Cookies from 'universal-cookie';
import { OverviewProvider } from '../../NmbsUser/context/OverviewProvider';
import Header from '../UI/Header/Header';
import {Login} from '../UI/Login/Login';
import Revenue from '../../BusinessPartner/components/Revenue';
import UserOverview from '../../NmbsUser/containers/UserOverview';
import Layout from '../../containers/Layout/Layout';
import Support from '../UI/Help/Support';
import Elearning from '../UI/Demovideo/Elearning';
import MonthlyIntakeBook from '../../IntakeBook/components/MonthlyIntakeBook';
import ChangeRequestOverview from '../../ChangeRequest/components/ChangeRequestOverview';
import Audit from '../../Audit/components/Audit';
import Reports from '../../Reports/components/Reports';
import sidebarConfig from '../../common/const/sidebarConfig.json';

const cookies = new Cookies();
export default class Root extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLogout : false,
            showUnblockModel: true,
            selectedNavItem : '',
            showElearningPopup: true
        }
    }

    setSelectedNavItem  = (selectedItem) => {
        this.setState( { selectedNavItem : selectedItem }); 
    };

    setShowUnblockModel = () => {
        this.setState( { showUnblockModel : false }); 
    };
    
    setShowElearningPopup = () => {
        this.setState( { showElearningPopup : false }); 
    };

    changeIsLogout = (isLoggedout) => {
        this.setState( { isLogout : isLoggedout }); 
    }; 

    isShowSidebarBottomContents = (pathname) => {
        return sidebarConfig && sidebarConfig.pathForSidebarBottomContents && 
             sidebarConfig.pathForSidebarBottomContents.length > 0 &&
             sidebarConfig.pathForSidebarBottomContents.includes(pathname);
    }

    BusinessPartnerPages = (pathname) => (
        <>
            <Route path="/revenue" exact 
                render={ () =>  <Revenue {...this.props}    isWeekly={true}
                                    isLogout={this.state.isLogout} 
                                    BusinessPartnerCode={this.props.businessPartnerCode} UserId={this.props.userId} 
                                    showUnblockModel={this.state.showUnblockModel}
                                    clearSessionData={() => this.props.clearSessionData()} 
                                    setSelectedNavItem ={(x) => this.setSelectedNavItem(x)} 
                                    onLogoutClick={(x) => this.changeIsLogout(x)}
                                    setShowUnblockModel={() => this.setShowUnblockModel()}
                                    setLogoutFalse={(x) => this.changeIsLogout(false)} 
                                    showElearningPopup={this.state.showElearningPopup}
                                    setShowElearningPopup={() => this.setShowElearningPopup()}
                                />
                } 
            />
            <Route path="/intakebook" exact 
                render={ () => <MonthlyIntakeBook {...this.props} 
                                BusinessPartnerCode={this.props.businessPartnerCode} UserId={this.props.userId} 
                                isLogout={this.state.isLogout} setLogoutFalse={(x) => this.changeIsLogout(false)} 
                                clearSessionData={() => this.props.clearSessionData()} 
                                onLogoutClick={(x) => this.changeIsLogout(x)}
                                setSelectedNavItem ={(x) => this.setSelectedNavItem(x)}
                            />
                } 
            />
            <Route path="/changerequest" exact 
                render={ () => <ChangeRequestOverview {...this.props} 
                    BusinessPartnerCode={this.props.businessPartnerCode} 
                    UserId={this.props.userId} 
                    isLogout={this.state.isLogout} setLogoutFalse={(x) => this.changeIsLogout(false)} 
                    clearSessionData={() => this.props.clearSessionData()} 
                    onLogoutClick={(x) => this.changeIsLogout(x)}
                    setSelectedNavItem ={(x) => this.setSelectedNavItem(x)}
                />} 
            />
            <Route path="/usermanual" exact 
                render={ () => <Support setSelectedNavItem ={(x) => this.setSelectedNavItem(x)} /> } 
            />
            <Route path="/usermanual" exact 
                render={ () => <Elearning setSelectedNavItem ={(x) => this.setSelectedNavItem(x)} /> } 
            />
            
            <Route path="/support" exact 
                render={ () => <Support BusinessPartnerCode={this.props.businessPartnerCode} 
                setSelectedNavItem ={(x) => this.setSelectedNavItem(x)} isLogout={this.state.isLogout}                 
                setLogoutFalse={(x) => this.changeIsLogout(false)} clearSessionData={() => this.props.clearSessionData()} 
                /> } 
            />
            <Route path="/elearning" exact 
                render={ () => <Elearning BusinessPartnerCode={this.props.businessPartnerCode} 
                setSelectedNavItem ={(x) => this.setSelectedNavItem(x)} isLogout={this.state.isLogout}                 
                setLogoutFalse={(x) => this.changeIsLogout(false)} clearSessionData={() => this.props.clearSessionData()} 
                /> } 
            />

            {pathname === "/" || pathname === "/revenue" ? <Redirect exact from="/" to="/revenue" /> 
                : pathname === "/intakebook" ? <Redirect exact from="/" to="/intakebook" /> 
                : pathname === "/changerequest" ? <Redirect exact from="/" to="/changerequest" /> 
                : pathname === "/usermanual" ? <Redirect exact from="/" to="/usermanual" /> 
                : pathname === "/support" ? <Redirect exact from="/" to="/support" /> 
                : pathname === "/elearning" ? <Redirect exact from="/" to="/elearning" /> 
                :  <Redirect to="/revenue" />} 
        </>
    ) 
    
    NmbsUserPages = (pathname) => (
        <>
            <Route path="/overview" exact 
                render={
                () => <OverviewProvider isEditAccess={this.props.isEditAccess} 
                            setSelectedNavItem ={(x) => this.setSelectedNavItem(x)}>
                            <UserOverview {...this.props}
                                UserId={this.props.userId} isLogout={this.state.isLogout} setLogoutFalse={() => this.changeIsLogout(false)}
                                clearSessionData={(x) => this.props.clearSessionData()} 
                                onLogoutClick={(x) => this.changeIsLogout(x)} 
                                showUnblockModel={this.state.showUnblockModel}
                                setShowUnblockModel={() => this.setShowUnblockModel()}
                            />
                    </OverviewProvider>
                } 
            />
            <Route path="/changerequest" exact 
                render={ () => <ChangeRequestOverview {...this.props} 
                    BusinessPartnerCode={this.props.businessPartnerCode} 
                    UserId={this.props.userId} 
                    isLogout={this.state.isLogout} 
                    isEditAccess={this.props.isEditAccess} 
                    isNmbsUser={this.props.isNmbsUser}
                    setLogoutFalse={(x) => this.changeIsLogout(false)} 
                    setSelectedNavItem ={(x) => this.setSelectedNavItem(x)}
                    clearSessionData={() => this.props.clearSessionData()} 
                    onLogoutClick={(x) => this.changeIsLogout(x)}
                />} 
            />
            {
                this.props.isEditAccess && <Route path="/audit" exact 
                    render={ () => <Audit {...this.props} 
                        UserId={this.props.userId} 
                        isLogout={this.state.isLogout} setLogoutFalse={(x) => this.changeIsLogout(false)} 
                        clearSessionData={() => this.props.clearSessionData()} 
                        onLogoutClick={(x) => this.changeIsLogout(x)}
                        setSelectedNavItem ={(x) => this.setSelectedNavItem(x)}
                    />} 
                />
            }
            <Route path="/reports" exact render={ () => <Reports {...this.props} 
                    isLogout={this.state.isLogout} setLogoutFalse={(x) => this.changeIsLogout(false)} 
                    clearSessionData={() => this.props.clearSessionData()} 
                    onLogoutClick={(x) => this.changeIsLogout(x)}
                    setSelectedNavItem ={(x) => this.setSelectedNavItem(x)}
                />}/>
            {(pathname === "/" || pathname === "/overview") ? <Redirect exact from="/" to="/overview" />
            : pathname === "/changerequest" ? <Redirect exact from="/" to="/changerequest" />
            : pathname === "/audit" && this.props.isEditAccess ? <Redirect exact from="/" to="/audit" />
            : pathname === "/reports" ? <Redirect exact from="/" to="/reports" /> 
            : <Redirect to="/overview" />}
        </>    
    )
    
    LoginPage = (isValidRedirectRoute,internalUsers) => (
        <>
            <Route path="/" exact render={() => <Login {...this.props} setIsLoading={this.props.setIsLoading} internalUsers ={internalUsers} />} />
            { !isValidRedirectRoute && <Redirect to="/" /> }
        </>
    )

    
    render() {
        const pathname = window.location.pathname;
        const internalUsers = pathname == '/internalUsers'? true: false;
        const isToken = cookies.get("token") && cookies.get("token") !== "";
        const isAuthenticated = localStorage.getItem('isAuth') && localStorage.getItem('isAuth') === "true";
        const isValidRedirectRoute = isToken && isAuthenticated && sidebarConfig && sidebarConfig.validRoutesPath 
                                    && sidebarConfig.validRoutesPath.length > 0 
                                    && sidebarConfig.validRoutesPath.includes(pathname);

        return (
        <Switch>
            
            <div className="grid-container">
                <Header appVersion={this.props.appVersion} isAuthenticate={this.props.isAuthenticate} userId={this.props.userId} changeIsLogout={(x) => this.changeIsLogout(x)} />
                <div className="main max-width-main">
                {
                    this.props.isAuthenticate ? 
                    <div className="App-content-background">
                        <Layout isBusinessPartnerUser={this.props.isBusinessPartnerUser}
                                isNmbsUser={this.props.isNmbsUser} selectedNavItem={this.state.selectedNavItem}
                                isShowSidebarBottomContents={this.isShowSidebarBottomContents(pathname)}
                                isEditAccess={this.props.isEditAccess} >
                                {this.props.isBusinessPartnerUser && this.BusinessPartnerPages(pathname) }
                                {this.props.isNmbsUser && this.NmbsUserPages(pathname) }
                        </Layout> 
                        
                    </div> 
                    : <div>
                        {
                            this.LoginPage(isValidRedirectRoute,internalUsers)
                        }
                    </div>
                }
                </div>
            </div>


        </Switch>
        )
    }
}
